export default __webpack_public_path__ + "static/terms-b261f9ce05f7c5392774b3854e24cff2.pdf";